import { useWidgetConfigContext } from '@/contexts/widget-config-context'

/**
 * The language a card's own labels speak: the card's (the reply it came with),
 * then the visitor's choice from the header, then the widget's.
 */
export function useCardLocale(cardLang?: unknown): string {
  const { widgetConfig, view } = useWidgetConfigContext()
  if (cardLang === 'ar' || cardLang === 'en') return cardLang
  return view.lang ?? widgetConfig.locale ?? 'en'
}
